import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import ModalButtonPanel from "../../shared/components/ModalButtonPanel";
import withModal from "../../shared/components/withModal";
import { groups, users } from "../actions";
import UserGroupToggle from "../components/UserGroupToggle";
import selectors from "../selectors";

export class AddUserGroup extends React.Component {
  state = {
    username: "",
    groupname: "",
    currentToggle: "group",
    valid: false
  };

  handleSubmit = event => {
    const { addUser, addGroup } = this.props;
    const { username, groupname, currentToggle } = this.state;
    event.preventDefault();
    if (currentToggle === "group") {
      addGroup(groupname);
    } else if (currentToggle === "user") {
      addUser(username);
    }
  };

  onUpdateUserGroup = newState => {
    this.setState({
      username: newState.username,
      groupname: newState.groupname
    });
  };

  setValidity = valid => {
    this.setState({ valid });
  };

  currentToggle = toggle => {
    this.setState({ currentToggle: toggle });
  };

  render() {
    const { valid, currentToggle } = this.state;
    const {
      groupsSaving,
      usersSaving,
      groupsError,
      usersError,
      parentUrl
    } = this.props;
    const saving = groupsSaving || usersSaving;
    const error = groupsError || usersError;
    const submitButtonTxt = `Add ${currentToggle}`;
    return (
      <div className="p-modal--add p-card">
        <div>
          {error && (
            <div className="p-notification--negative">
              <p className="p-notification__response">
                <span className="p-notification__status">Error:</span>
                {error.description}
              </p>
            </div>
          )}
          <form>
            <UserGroupToggle
              heading="Add a new Group or User"
              currentToggle={this.currentToggle}
              onUpdate={this.onUpdateUserGroup}
              isValid={this.setValidity}
            />
            <ModalButtonPanel
              parentUrl={parentUrl}
              onSubmit={this.handleSubmit}
              submitButtonTxt={submitButtonTxt}
              disabled={!valid}
              inProgress={saving}
            />
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  groupsError: selectors.groups.getError(state),
  usersError: selectors.users.getError(state),
  groupsSaving: state.groups.saving,
  usersSaving: state.users.saving
});

const mapDispatchToProps = {
  addGroup: groups.add,
  addUser: users.add
};

AddUserGroup.propTypes = {
  parentUrl: PropTypes.string.isRequired,
  addGroup: PropTypes.func.isRequired,
  groupsError: PropTypes.shape({
    description: PropTypes.string.isRequired,
    error: PropTypes.string.isRequired
  }),
  groupsSaving: PropTypes.bool,
  addUser: PropTypes.func.isRequired,
  usersError: PropTypes.shape({
    description: PropTypes.string.isRequired,
    error: PropTypes.string.isRequired
  }),
  usersSaving: PropTypes.bool
};

AddUserGroup.defaultProps = {
  usersError: undefined,
  groupsError: undefined,
  groupsSaving: false,
  usersSaving: false
};

export default withModal(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AddUserGroup)
);
